import { EMBEDS_URL } from '../lib/embeds-url';
import type { NodeProps } from '../types';
import { BaseEmbed } from './lib/base-embed';

export function CalculatedFieldsForm({ props }: NodeProps<{ id: string; height?: number }>) {
  if (!props.id) return null;

  const src = `${EMBEDS_URL}/cff/?form_id=${props.id}&nwaMode=embed`;

  return (
    <div className="shadow-[0_4px_8px_0_rgb(100_102_106/0.1),0_1px_4px_0_rgb(100_102_106/0.36)]">
      <BaseEmbed src={src} title="Calculated Fields Form" />
    </div>
  );
}
